import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface Relation {
  id: number;
  source_item_id: number;
  source_nome: string;
  source_tipo: string;
  target_item_id: number;
  target_nome: string;
  target_tipo: string;
  tipo_relacao: string;
  origem: 'auto' | 'manual';
  criado_em: string;
}

interface RelationsResponse {
  outgoing: Relation[];
  backlinks: Relation[];
  counts: { outgoing: number; backlinks: number };
}

export function useRelations(itemId: number | null): UseQueryResult<RelationsResponse> {
  return useQuery({
    queryKey: ['relations', itemId],
    queryFn: () => api<RelationsResponse>(`/api/items/${itemId}/relations`),
    enabled: itemId !== null,
  });
}
